import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Select, { components } from 'react-select';
import { Layers, Plus } from 'lucide-react';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faTag } from '@fortawesome/free-solid-svg-icons';

const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)',
        opacity: 0.6
    }),
    input: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: '14px',
        color: state.isSelected ? 'white' : 'var(--form-control-color)'
    })
};

const BIZ_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g>
            <path d="M9.43582 5.9987C9.26448 5.9987 9.12137 5.9412 9.00648 5.8262C8.89148 5.71131 8.83398 5.56692 8.83398 5.39303V2.93786C8.83398 2.76386 8.89193 2.61942 9.00782 2.50453C9.12371 2.38953 9.26726 2.33203 9.43848 2.33203H13.0655C13.2368 2.33203 13.3799 2.38953 13.4948 2.50453C13.6098 2.61942 13.6673 2.76386 13.6673 2.93786V5.39303C13.6673 5.56692 13.6094 5.71131 13.4935 5.8262C13.3776 5.9412 13.234 5.9987 13.0628 5.9987H9.43582ZM2.93582 8.33203C2.76448 8.33203 2.62137 8.27453 2.50648 8.15953C2.39148 8.04453 2.33398 7.90203 2.33398 7.73203V2.93186C2.33398 2.76186 2.39193 2.61942 2.50782 2.50453C2.62371 2.38953 2.76726 2.33203 2.93848 2.33203H6.56548C6.73682 2.33203 6.87993 2.38953 6.99482 2.50453C7.10982 2.61953 7.16732 2.93203 7.16732 2.93203V7.7322C7.16732 7.9022 7.10937 8.04464 6.99348 8.15953C6.8776 8.27453 6.73404 8.33203 6.56282 8.33203H2.93582ZM9.43582 13.6654C9.26448 13.6654 9.12137 13.6079 9.00648 13.4929C8.89148 13.3779 8.83398 13.2354 8.83398 13.0654V8.2652C8.83398 8.0952 8.89193 7.95275 9.00782 7.83786C9.12371 7.72286 9.26726 7.66536 9.43848 7.66536H13.0655C13.2368 7.66536 13.3799 7.72286 13.4948 7.83786C13.6098 7.95286 13.6673 8.09536 13.6673 8.26536V13.0655C13.6673 13.2355 13.6094 13.378 13.4935 13.4929C13.3776 13.6079 13.234 13.6654 13.0628 13.6654H9.43582ZM2.93582 13.6654C2.76448 13.6654 2.62137 13.6079 2.50648 13.4929C2.39148 13.378 2.33398 13.2335 2.33398 13.0595V10.6044C2.33398 10.4305 2.39193 10.2861 2.50782 10.1712C2.62371 10.0562 2.76726 9.9987 2.93848 9.9987H6.56548C6.73682 9.9987 6.87993 10.0562 6.99482 10.1712C7.10982 10.2861 7.16732 10.4305 7.16732 10.6044V13.0595C7.16732 13.2335 7.10937 13.378 6.99348 13.4929C6.8776 13.6079 6.73404 13.6654 6.56282 13.6654H2.93582Z" fill="currentColor" />
        </g>
    </svg>
);

const FN_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g>
            <path d="M3.077 12.6654C2.77011 12.6654 2.51389 12.5626 2.30833 12.357C2.10278 12.1515 2 11.8953 2 11.5884V4.40903C2 4.10214 2.10278 3.84592 2.30833 3.64036C2.51389 3.43481 2.77011 3.33203 3.077 3.33203H5.95C6.09356 3.33203 6.23311 3.36109 6.36867 3.4192C6.50411 3.47731 6.62011 3.55464 6.71667 3.6512L7.73083 4.66536H12.923C13.2299 4.66536 13.4861 4.76814 13.6917 4.9737C13.8972 5.17925 14 5.43548 14 5.74236V11.5884C14 11.8953 13.8972 12.1515 13.6917 12.357C13.4861 12.5626 13.2299 12.6654 12.923 12.6654H3.077Z" fill="currentColor" />
        </g>
    </svg>
);

const KPI_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18" fill="none">
        <path d="M14.7695 3.375C15.1483 3.37508 15.469 3.50613 15.7314 3.76855C15.9939 4.03098 16.1249 4.35174 16.125 4.73047V13.2695C16.1249 13.6483 15.9939 13.969 15.7314 14.2314C15.469 14.4939 15.1483 14.6249 14.7695 14.625H3.23047C2.85174 14.6249 2.53098 14.4939 2.26855 14.2314C2.00613 13.969 1.87508 13.6483 1.875 13.2695V4.73047C1.87508 4.35174 2.00613 4.03098 2.26855 3.76855C2.53098 3.50613 2.85174 3.37508 3.23047 3.375H14.7695ZM4.5 6.75V10.8281H5.49316V9.02734L6.86426 10.8281H8.0791L6.44043 8.74902L8.02051 6.75H6.85254L5.49316 8.53906V6.75H4.5ZM8.55078 10.8281H9.54395V9.36426H10.1602C11.1999 9.36426 11.659 8.73726 11.6592 8.06348C11.6592 7.314 11.1595 6.75 10.1602 6.75H8.55078V10.8281ZM12.1768 10.8281H13.1699V6.75H12.1768V10.8281ZM10.085 7.55176C10.4799 7.55183 10.6484 7.7498 10.6484 8.06348C10.6483 8.3769 10.4797 8.57414 10.085 8.57422H9.54395V7.55176H10.085Z" fill="currentColor" />
    </svg>
);

const DS_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M13.166 3.93695V5.00837C13.166 5.95257 10.8145 6.72266 7.91602 6.72266C5.01757 6.72266 2.66602 5.95257 2.66602 5.00837V3.93695C2.66602 2.99274 5.01757 2.22266 7.91602 2.22266C10.8145 2.22266 13.166 2.99274 13.166 3.93695ZM13.166 6.34766V8.75837C13.166 9.70257 10.8145 10.4727 7.91602 10.4727C5.01757 10.4727 2.66602 9.70257 2.66602 8.75837V6.34766C3.79395 7.12445 5.85839 7.48606 7.91602 7.48606C9.97364 7.48606 12.0381 7.12445 13.166 6.34766ZM13.166 10.0977V12.5084C13.166 13.4526 10.8145 14.2227 7.91602 14.2227C5.01757 14.2227 2.66602 13.4526 2.66602 12.5084V10.0977C3.79395 10.8744 5.85839 11.2361 7.91602 11.2361C9.97364 11.2361 12.0381 10.8744 13.166 10.0977Z" fill="currentColor"/>
    </svg>
);

// Icon label renderer for select dropdowns
const IconLabel = ({ icon, label }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span className="tw-text-[#788097] dark:tw-text-white tw-shrink-0" style={{ display: 'inline-flex', alignItems: 'center' }}>
            {icon}
        </span>
        <span style={{ fontSize: '14px' }}>{label}</span>
    </div>
);

// Factory to create custom Option and SingleValue components with icons
const makeIconComponents = (icon) => ({
    Option: (props) => (
        <components.Option {...props}>
            <IconLabel icon={icon} label={props.data.label} />
        </components.Option>
    ),
    SingleValue: (props) => (
        <components.SingleValue {...props}>
            <IconLabel icon={icon} label={props.data.label} />
        </components.SingleValue>
    )
});

const bizBadgeComponents = makeIconComponents(BIZ_SVG);
const fnBadgeComponents = makeIconComponents(FN_SVG);
const kpiBadgeComponents = makeIconComponents(KPI_SVG);
const dsBadgeComponents = makeIconComponents(DS_SVG);

class AddMappingModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialFormState();
    }

    getInitialFormState() {
        return {
            bizId: '',
            fnId: '',
            kpiId: '',
            modelId: '',
            datasource: '',
            selectedDatasets: new Set(),
            selectedAttributes: new Set(),
            itemType: 'kpi', // 'kpi' or 'model'
            formulaValue: '',
            manualConfig: true
        };
    }

    componentDidUpdate(prevProps) {
        const opened = this.props.show && !prevProps.show;
        const mappingChanged = this.props.editingMapping !== prevProps.editingMapping;

        if (opened || (this.props.show && mappingChanged)) {
            if (this.props.editingMapping) {
                const { kpis, assets, mappings = [] } = this.props;
                const m = this.props.editingMapping;
                const kpiId = m.kpiId;
                const k = kpis.find(item => item.id === kpiId);

                const relatedMappings = (mappings || []).filter(item => item.kpiId === kpiId);
                const seedAssetIds = relatedMappings.length
                    ? relatedMappings.map(item => item.assetId)
                    : (m.assetId ? [m.assetId] : (m.mappingIds
                        ? (mappings || []).filter(item => m.mappingIds.includes(item.id)).map(item => item.assetId)
                        : []));
                const relatedAssets = seedAssetIds
                    .map(id => assets.find(a => a.id === id))
                    .filter(Boolean);

                // Prefer the datasource that covers the most existing mappings
                const dsCounts = {};
                relatedAssets.forEach(a => {
                    dsCounts[a.datasource] = (dsCounts[a.datasource] || 0) + 1;
                });
                const datasource = Object.keys(dsCounts).sort((a, b) => dsCounts[b] - dsCounts[a])[0]
                    || (relatedAssets[0] && relatedAssets[0].datasource)
                    || '';

                const assetsForDs = relatedAssets.filter(a => !datasource || a.datasource === datasource);

                this.setState({
                    bizId: k ? this.getBizIdFromFn(k.functionId) : '',
                    fnId: k ? k.functionId : '',
                    kpiId: k ? k.id : '',
                    modelId: '',
                    itemType: 'kpi',
                    datasource,
                    selectedDatasets: new Set(assetsForDs.map(a => a.dataset)),
                    selectedAttributes: new Set(assetsForDs.map(a => a.id)),
                    formulaValue: k ? (k.formula || '') : ''
                });
            } else {
                this.setState(this.getInitialFormState());
            }
        }
    }

    getBizIdFromFn(fnId) {
        const { functions } = this.props;
        const f = functions.find(item => item.id === fnId);
        return f ? f.businessId : '';
    }

    onFieldChange = (field, val) => {
        const nextState = { [field]: val };
        if (field === 'bizId') {
            nextState.fnId = '';
            nextState.kpiId = '';
            nextState.modelId = '';
            nextState.formulaValue = '';
        } else if (field === 'fnId') {
            nextState.kpiId = '';
            nextState.modelId = '';
            nextState.formulaValue = '';
        } else if (field === 'kpiId') {
            const selectedKpi = this.props.kpis.find(k => k.id === val);
            nextState.formulaValue = selectedKpi ? (selectedKpi.formula || '') : '';
        } else if (field === 'datasource') {
            nextState.selectedDatasets = new Set();
            nextState.selectedAttributes = new Set();
        }
        this.setState(nextState);
    };

    toggleDataset = (datasetName, checked) => {
        const nextDatasets = new Set(this.state.selectedDatasets);
        if (checked) {
            nextDatasets.add(datasetName);
        } else {
            nextDatasets.delete(datasetName);
        }
        
        // Drop selected attributes not in checked datasets
        const { assets } = this.props;
        const nextAttributes = new Set(this.state.selectedAttributes);
        [...nextAttributes].forEach(assetId => {
            const a = assets.find(x => x.id === assetId);
            if (a && !nextDatasets.has(a.dataset)) {
                nextAttributes.delete(assetId);
            }
        });
        
        this.setState({
            selectedDatasets: nextDatasets,
            selectedAttributes: nextAttributes
        });
    };

    toggleAllDatasets = () => {
        const { assets } = this.props;
        const { datasource, selectedDatasets } = this.state;
        const availableDatasets = datasource
            ? [...new Set(assets.filter(a => a.datasource === datasource).map(a => a.dataset))]
            : [...new Set(assets.map(a => a.dataset))];
        const allOn = availableDatasets.every(d => selectedDatasets.has(d));
        
        if (allOn) {
            this.setState({
                selectedDatasets: new Set(),
                selectedAttributes: new Set()
            });
        } else {
            this.setState({
                selectedDatasets: new Set(availableDatasets)
            });
        }
    };

    toggleAttribute = (assetId, checked) => {
        const nextAttributes = new Set(this.state.selectedAttributes);
        if (checked) {
            nextAttributes.add(assetId);
        } else {
            nextAttributes.delete(assetId);
        }
        this.setState({ selectedAttributes: nextAttributes });
    };

    toggleAllAttributes = () => {
        const { assets } = this.props;
        const { datasource, selectedDatasets, selectedAttributes } = this.state;
        const allRelevantAssets = selectedDatasets.size > 0
            ? assets.filter(a => (!datasource || a.datasource === datasource) && selectedDatasets.has(a.dataset))
            : assets.filter(a => (!datasource || a.datasource === datasource));
        const allOn = allRelevantAssets.length && allRelevantAssets.every(a => selectedAttributes.has(a.id));
        
        const nextAttributes = new Set(selectedAttributes);
        if (allOn) {
            allRelevantAssets.forEach(a => nextAttributes.delete(a.id));
        } else {
            allRelevantAssets.forEach(a => nextAttributes.add(a.id));
        }
        this.setState({ selectedAttributes: nextAttributes });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { kpiId, datasource, selectedAttributes, formulaValue } = this.state;
        const { assets, onSave, editingMapping } = this.props;

        if (!kpiId || !datasource || selectedAttributes.size === 0) {
            return;
        }

        const mappingsArray = [];
        let index = 0;
        const stamp = Date.now();
        selectedAttributes.forEach(assetId => {
            const matchedAsset = assets.find(a => a.id === assetId);
            if (matchedAsset) {
                mappingsArray.push({
                    id: `m_gen_${stamp}_${index}`,
                    kpiId,
                    assetId: matchedAsset.id,
                    asset: matchedAsset,
                    status: 'manual',
                    enabled: editingMapping ? (editingMapping.enabled !== false) : true
                });
                index++;
            }
        });

        onSave({
            mappings: mappingsArray,
            replaceKpiId: editingMapping ? kpiId : null,
            replaceMappingId: null,
            formulaUpdate: {
                id: kpiId,
                formula: formulaValue.trim()
            }
        });
        this.setState(this.getInitialFormState());
    };

    render() {
        const { show, onClose, editingMapping, businesses, functions, kpis, assets } = this.props;
        const { bizId, fnId, kpiId, datasource, selectedDatasets, selectedAttributes, formulaValue } = this.state;

        // Cascade filters
        const filteredFunctions = functions.filter(f => !bizId || f.businessId === bizId);
        const filteredKpis = kpis.filter(k => !fnId || k.functionId === fnId);

        // Get unique datasources and datasets
        const availableDatasources = [...new Set(assets.map(a => a.datasource))];
        const availableDatasets = datasource
            ? [...new Set(assets.filter(a => a.datasource === datasource).map(a => a.dataset))]
            : [...new Set(assets.map(a => a.dataset))];

        const selectedKpi = kpis.find(k => k.id === kpiId);

        const isFormValid = kpiId && datasource && selectedAttributes.size > 0;

        return (
            <Modal 
                show={show} 
                onHide={onClose}
                dialogClassName="modal-vertical shadow" 
                className="fixed-right model__help modal-integration" 
                size="xl"
            >
                <form onSubmit={this.handleSubmit} className="tw-flex tw-flex-col tw-h-full">
                    {/* Header */}
                    <Modal.Header closeButton>
                        <div className='tw-flex tw-items-center tw-gap-4'>
                            <div className='tw-flex tw-items-center tw-justify-center tw-p-[10px] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/20 tw-bg-white dark:tw-bg-white/10 tw-rounded-[10px]'>
                                <Plus size={20} color="currentColor" className="tw-text-[#414651] dark:tw-text-white" />
                            </div>
                            <div>
                                <h5 className="modal-title !tw-mb-[2px] tw-font-semibold !tw-text-gray-900 dark:!tw-text-white">
                                    {editingMapping ? "Edit mapping" : "Add mapping"}
                                </h5>                                
                                <div className='tw-flex tw-items-center tw-gap-2'>
                                    <p className='tw-text-sm tw-font-medium tw-text-[#525252] dark:tw-text-gray-400 tw-m-0'>Bind a business KPI to one or more data attributes</p>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>

                    {/* Body */}
                    <Modal.Body className="tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden !tw-p-0 scr">
                        <div className="qd-configure-integration-steps !tw-p-5">
                            <div className="vertical-stepper vertical-stepper-sm w-100 border-0">
                                
                                {/* STEP 1: Business KPI */}
                                <div className="vertical-stepper__heading !tw-pb-[2px]">
                                    <span className="vs-heading__circle">1</span>
                                    <div>
                                        <div className="vs-heading__title">Business KPI</div>
                                    </div>
                                </div>
                                <div className="vertical-stepper__content !tw-pt-0 !tw-pb-8 tw-space-y-4">
                                    <div className="tw-text-xs tw-text-[#535862] dark:tw-text-[#85888E] tw-font-medium tw-mt-[2px]">
                                        {"Business > Function > KPI"}
                                    </div>
                                    <div>
                                        <label>BUSINESS</label>
                                        <Select
                                            id="nm-biz"
                                            className="has-badge"
                                            classNamePrefix="select-control"
                                            placeholder="Select business"
                                            options={businesses.map(b => ({ value: b.id, label: b.name }))}
                                            value={businesses.map(b => ({ value: b.id, label: b.name })).find(o => o.value === bizId) || null}
                                            onChange={opt => this.onFieldChange('bizId', opt ? opt.value : '')}
                                            components={bizBadgeComponents}
                                            styles={customSelectStyles}
                                        />
                                    </div>

                                    <div>
                                        <label>FUNCTION</label>
                                        <Select
                                            id="nm-fn"
                                            className="has-badge"
                                            classNamePrefix="select-control"
                                            placeholder="Select function"
                                            options={filteredFunctions.map(f => ({ value: f.id, label: f.name }))}
                                            value={filteredFunctions.map(f => ({ value: f.id, label: f.name })).find(o => o.value === fnId) || null}
                                            onChange={opt => this.onFieldChange('fnId', opt ? opt.value : '')}
                                            isDisabled={!bizId}
                                            components={fnBadgeComponents}
                                            styles={customSelectStyles}
                                        />
                                    </div>

                                    <div>
                                        <label>KPI</label>
                                        <Select
                                            id="nm-kpi"
                                            className="has-badge"
                                            classNamePrefix="select-control"
                                            placeholder="Select KPI"
                                            options={filteredKpis.map(k => ({ value: k.id, label: k.name }))}
                                            value={filteredKpis.map(k => ({ value: k.id, label: k.name })).find(o => o.value === kpiId) || null}
                                            onChange={opt => this.onFieldChange('kpiId', opt ? opt.value : '')}
                                            isDisabled={!fnId}
                                            components={kpiBadgeComponents}
                                            styles={customSelectStyles}
                                        />
                                    </div>

                                    <div className="tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-white/5 tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-white/10 tw-p-3.5 tw-space-y-3">
                                        <p className="tw-text-xs !tw-text-[#546AC3] dark:tw-text-[#60A5FA] tw-leading-relaxed tw-mb-0">
                                            {selectedKpi 
                                                ? (selectedKpi.description || <span className="tw-text-gray-400 tw-italic">No description available.</span>) 
                                                : "Read-only description of the selected KPI (e.g., \"Total revenue across all regions\")."}
                                        </p>
                                        <Form.Group>
                                            <Form.Label>Formula</Form.Label>
                                            <div className="icon-input-group">
                                                <i><Layers size={18} color="#A4A7AE" /></i>
                                                <Form.Control
                                                    type="text"
                                                    name="sub_path"
                                                    placeholder="e.g. SUM(sales.amount)"
                                                    value={formulaValue}
                                                    onChange={e => this.setState({ formulaValue: e.target.value })}
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                                {/* STEP 2: Data Assets */}
                                <div className="vertical-stepper__heading !tw-pb-[2px]">
                                    <span className="vs-heading__circle">2</span>
                                    <div>
                                        <div className="vs-heading__title">Data assets</div>
                                    </div>
                                </div>
                                <div className="vertical-stepper__content !tw-pt-0 !tw-pb-8 tw-space-y-4">
                                    <div className="tw-text-xs tw-text-[#535862] dark:tw-text-[#85888E] tw-font-medium tw-mt-[2px]">
                                        {"Datasource > Datasets > Attributes"}
                                    </div>
                                    <div className="tw-bg-[#FAFAFA] dark:tw-bg-white/5 tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-white/10 tw-rounded-[8px] tw-p-3 tw-space-y-4">
                                        <div>
                                            <label>DATASOURCE</label>
                                            <Select
                                                id="nm-ds"
                                                className="has-badge"
                                                classNamePrefix="select-control"
                                                placeholder="Select datasource"
                                                options={availableDatasources.map(d => ({ value: d, label: d }))}
                                                value={availableDatasources.map(d => ({ value: d, label: d })).find(o => o.value === datasource) || null}
                                                onChange={opt => this.onFieldChange('datasource', opt ? opt.value : '')}
                                                components={dsBadgeComponents}
                                                styles={customSelectStyles}
                                            />
                                        </div>

                                        {/* Divider line below datasource */}
                                        <div className="tw-border-0 tw-border-b tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10"></div>

                                        <div>
                                            <label className="tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium tw-text-[#535862] dark:tw-text-[#B2B5BE] tw-mb-2">
                                                <span>DATASETS</span>
                                                <span className="tw-text-xs tw-font-medium tw-text-[#414651] dark:tw-text-white tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-full tw-px-2 tw-py-0.5">
                                                    {selectedDatasets.size} selected
                                                </span>
                                            </label>
                                            <div id="nm-datasets" className="tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-[8px] tw-max-h-[168px] tw-overflow-y-auto tw-overflow-x-hidden tw-bg-white dark:tw-bg-[#2B2B40]">
                                                <div className="tw-flex tw-items-center tw-justify-between tw-px-3 tw-py-1.5 tw-border-0 tw-border-b tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-sticky tw-top-0 tw-z-1 tw-bg-white dark:tw-bg-[#2B2B40]">
                                                    <button 
                                                        type="button" 
                                                        className="tw-text-14 tw-font-medium tw-text-[#007BFF] dark:tw-text-white hover:tw-underline tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer" 
                                                        onClick={() => {
                                                            this.setState({ selectedDatasets: new Set(availableDatasets) });
                                                        }}
                                                    >
                                                        Select all
                                                    </button>
                                                    <button 
                                                        type="button" 
                                                        className="tw-text-14 tw-font-medium tw-text-[#007BFF] dark:tw-text-white hover:tw-underline tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer" 
                                                        onClick={() => {
                                                            this.setState({ selectedDatasets: new Set(), selectedAttributes: new Set() });
                                                        }}
                                                    >
                                                        Clear all
                                                    </button>
                                                </div>
                                                {availableDatasets.length === 0 ? (
                                                    <div className="tw-p-3.5 tw-text-xs tw-text-gray-400 dark:tw-text-[#85888E] tw-text-center">No datasets in this datasource</div>
                                                ) : (
                                                    availableDatasets.map(d => {
                                                        const count = assets.filter(a => (!datasource || a.datasource === datasource) && a.dataset === d).length;
                                                        return (
                                                            <label key={d} className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-cursor-pointer tw-border-0 tw-border-b tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/5 last:tw-border-b-0 hover:tw-bg-[#F8FAFF] dark:hover:tw-bg-white/5 tw-transition-colors tw-mb-0 tw-w-full tw-min-w-0 tw-overflow-hidden">
                                                                <input 
                                                                    type="checkbox" 
                                                                    checked={selectedDatasets.has(d)} 
                                                                    onChange={e => this.toggleDataset(d, e.target.checked)} 
                                                                    className="tw-w-[15px] tw-h-[15px] tw-rounded tw-accent-blue-600 tw-cursor-pointer"
                                                                />
                                                                <FontAwesomeIcon icon={faLayerGroup} className="tw-text-[#A4A7AE] dark:tw-text-[#B2B5BE]" style={{ width: '12px', height: '12px' }} />
                                                                <span className="tw-flex-1 tw-min-w-0">
                                                                    <span className="tw-text-sm tw-text-[#181D27] dark:tw-text-white tw-font-medium tw-truncate tw-block">{d}</span>
                                                                </span>
                                                                <span className="tw-text-xs tw-font-medium tw-text-[#535862] dark:tw-text-[#85888E]">{count} attribute{count !== 1 ? 's' : ''}</span>
                                                            </label>
                                                        );
                                                    })
                                                )}
                                            </div>
                                        </div>

                                        {/* Divider line between dataset and attributes */}
                                        <div className="tw-border-0 tw-border-b tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10"></div>

                                        <div>
                                            <label className="tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium tw-text-[#535862] dark:tw-text-[#B2B5BE] tw-mb-2">
                                                <span>ATTRIBUTES</span>
                                                <span className="tw-text-xs tw-font-medium tw-text-[#414651] dark:tw-text-white tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-full tw-px-2 tw-py-0.5">
                                                    {selectedAttributes.size} selected
                                                </span>
                                            </label>
                                            <div id="nm-attrs" className="tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-[8px] tw-max-h-[168px] tw-overflow-y-auto tw-overflow-x-hidden tw-bg-white dark:tw-bg-[#2B2B40]">
                                                {(() => {
                                                    const allRelevantAssets = selectedDatasets.size > 0
                                                        ? assets.filter(a => (!datasource || a.datasource === datasource) && selectedDatasets.has(a.dataset))
                                                        : assets.filter(a => (!datasource || a.datasource === datasource));
                                                    
                                                    if (allRelevantAssets.length === 0) {
                                                        return <div className="tw-p-3.5 tw-text-xs tw-text-gray-400 dark:tw-text-[#85888E] tw-text-center">No attributes available</div>;
                                                    }

                                                    return (
                                                        <>
                                                            <div className="tw-flex tw-items-center tw-justify-between tw-px-3 tw-py-1.5 tw-border-0 tw-border-b tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-sticky tw-top-0 tw-z-1 tw-bg-white dark:tw-bg-[#2B2B40]">
                                                                <button 
                                                                    type="button" 
                                                                    className="tw-text-14 tw-font-medium tw-text-[#007BFF] dark:tw-text-white hover:tw-underline tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer" 
                                                                    onClick={() => {
                                                                        const nextAttributes = new Set(selectedAttributes);
                                                                        allRelevantAssets.forEach(a => nextAttributes.add(a.id));
                                                                        this.setState({ selectedAttributes: nextAttributes });
                                                                    }}
                                                                >
                                                                    Select all
                                                                </button>
                                                                <button 
                                                                    type="button" 
                                                                    className="tw-text-14 tw-font-medium tw-text-[#007BFF] dark:tw-text-white hover:tw-underline tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer" 
                                                                    onClick={() => {
                                                                        const nextAttributes = new Set(selectedAttributes);
                                                                        allRelevantAssets.forEach(a => nextAttributes.delete(a.id));
                                                                        this.setState({ selectedAttributes: nextAttributes });
                                                                    }}
                                                                >
                                                                    Clear all
                                                                </button>
                                                            </div>
                                                            {(() => {
                                                                const datasetsInRelevantAssets = [...new Set(allRelevantAssets.map(a => a.dataset))];
                                                                return datasetsInRelevantAssets.map(datasetName => {
                                                                    const assetsInDataset = allRelevantAssets.filter(a => a.dataset === datasetName);
                                                                    return (
                                                                        <React.Fragment key={datasetName}>
                                                                            <div className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-bg-[#FAFAFA] dark:tw-bg-white/5 tw-border-0 tw-border-b tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/5 tw-sticky tw-top-[32px] tw-z-1">
                                                                                <FontAwesomeIcon icon={faLayerGroup} className="tw-text-[#A4A7AE] dark:tw-text-[#B2B5BE]" style={{ width: '12px', height: '12px' }} />
                                                                                <span className="tw-text-[11px] tw-font-bold tw-text-[#535862] dark:tw-text-[#B2B5BE] tw-uppercase tw-tracking-wider">
                                                                                    {datasetName}
                                                                                </span>
                                                                            </div>
                                                                            {assetsInDataset.map(a => (
                                                                                <label key={a.id} className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-cursor-pointer tw-border-0 tw-border-b tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/5 last:tw-border-b-0 hover:tw-bg-[#F8FAFF] dark:hover:tw-bg-white/5 tw-transition-colors tw-mb-0 tw-w-full tw-min-w-0 tw-overflow-hidden">
                                                                                    <input 
                                                                                        type="checkbox" 
                                                                                        checked={selectedAttributes.has(a.id)} 
                                                                                        onChange={e => this.toggleAttribute(a.id, e.target.checked)} 
                                                                                        className="tw-w-[15px] tw-h-[15px] tw-rounded tw-accent-blue-600 tw-cursor-pointer"
                                                                                    />
                                                                                    <FontAwesomeIcon icon={faTag} className="tw-text-[#A4A7AE] dark:tw-text-[#B2B5BE]" style={{ width: '12px', height: '12px' }} />
                                                                                    <span className="tw-flex-1 tw-min-w-0">
                                                                                        <span className="tw-text-xs tw-text-gray-800 dark:tw-text-white tw-font-medium tw-truncate tw-block">
                                                                                            {a.attribute}
                                                                                        </span>
                                                                                    </span>
                                                                                </label>
                                                                            ))}
                                                                        </React.Fragment>
                                                                    );
                                                                });
                                                            })()}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal.Body>

                    {/* Footer */}
                    <div className="tw-flex tw-items-center tw-justify-between tw-py-3 tw-px-5 tw-border-0 tw-border-t tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-bg-white dark:tw-bg-white/5 tw-shrink-0">
                        <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-text-slate-500 dark:tw-text-[#B2B5BE]">
                            {isFormValid ? (
                                <span>
                                    Creates <b>{selectedAttributes.size}</b> mapping{selectedAttributes.size > 1 ? 's' : ''} <span className="tw-text-gray-400">·</span> marked <b className="tw-text-indigo-600 dark:tw-text-[#818CF8]">Manual</b>
                                </span>
                            ) : (
                                    <span className="tw-text-[#535862]">
                                    Pick a KPI and at least one attribute
                                </span>
                            )}
                        </div>
                        <div className="tw-flex tw-items-center tw-gap-2">
                            <button 
                                type="button" 
                                onClick={onClose}
                                className="tw-inline-flex tw-items-center tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-lg hover:tw-bg-gray-50 dark:hover:tw-bg-[#3A3A55] tw-transition-colors"
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit" 
                                disabled={!isFormValid}
                                className="btn btn-primary"
                            >
                                {editingMapping ? 'Save Changes' : '+ Add mapping'}
                            </button>
                        </div>
                    </div>
                </form>
            </Modal>
        );
    }
}

export default AddMappingModal;
